// extracted by mini-css-extract-plugin
export default {"root":"FieldSelectableItem_root__XGLk0","input":"FieldSelectableItem_input__VIm2N","label":"FieldSelectableItem_label__jhTkN"};